// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8qk37{font:var(--ds-font-body-UNSAFE_small,normal 400 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}\n._zulp5l1i{gap:.5rem .5rem}\n._19pkcxkx{margin-top:var(--ds-space-100,.5rem)}\n._1bahesu3{justify-content:flex-end}\n._bpsp1wq8 a{font-weight:var(--ds-font-weight-medium,500)}", ""]);
// Exports
module.exports = exports;
